
import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.pauseDownloadTask = wxBridge.pauseDownloadTask  || function(param, callback) {

    // begin log
    if ( window.logInfo ) {
        logInfo('pauseDownloadTask begin', param)
    }

    wxBridge.invoke('pauseDownloadTask', param, function(res) {
        // begin log
        if ( window.logInfo ) {
            logInfo('pauseDownloadTask begin', res)
        }

        callback(res)
    });
};

export default wxBridge;

export const {
    pauseDownloadTask
} = wxBridge;
